import { createWidgetWithErrorBoundary } from '@alfa-bank/site-util-create-widget/create-widget-with-error-boundary';

import type { IAnalyticsSpy } from './models';
import { AnalyticsSpy as Component } from './spy';

export const AnalyticsSpy = createWidgetWithErrorBoundary<unknown, IAnalyticsSpy>({})(Component);
